import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import URLstateContext from "../../../provider/CommonContext";


function MFActivitiChart() {
  const [data, getData] = useState("")
  const [chartData, setchartData] = useState([]);
  const [valueLi, setchartperiod] = useState('1WEEK');
  const { BaseURL } = useContext(URLstateContext);
  const [Performance, setPerformance] = useState('EQUITY');
  let getchartData, indicator;

  useEffect(() => {
    const getUrlMfActivitychart = BaseURL + "MFActivityChart";
    // setchartperiod('1WEEK');
    // alert(`${getUrlMfActivitychart}/${Performance}/${valueLi}/GROWTH/-`)
    fetch(`${getUrlMfActivitychart}/${Performance}/${valueLi}/GROWTH/-`)
      .then((response) => response.json())
      .then((datachart) => {
        getchartData = datachart.data;
        setchartData(getchartData);
        getData(datachart.data)

        // console.log(getchartData, "getchartData")
      })
      .catch((error) => {
      });
  }, [Performance, valueLi]);




  useLayoutEffect(() => {


    // Create root element
    // https://www.amcharts.com/docs/v5/getting-started/#Root_element
    var root = am5.Root.new("chartdivactivity");


    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([
      am5themes_Animated.new(root)
    ]);


    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    var chart = root.container.children.push(am5xy.XYChart.new(root, {
      panX: true,
      panY: true,
      wheelX: "panX",
      wheelY: "zoomX",
      pinchZoomX: true
    }));

    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineY.set("visible", false);


    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    var xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
    xRenderer.labels.template.setAll({
      rotation: -40,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 0,
      fontSize: 1.0,
    });

    var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
      maxDeviation: 0.3,
      categoryField: "country",
      renderer: xRenderer,
      tooltip: am5.Tooltip.new(root, {})
    }));

    var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
      maxDeviation: 0.3,
      renderer: am5xy.AxisRendererY.new(root, {})
    }));


    // Create series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    var series = chart.series.push(am5xy.ColumnSeries.new(root, {
      name: "Series 1",
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "value",
      sequencedInterpolation: true,
      stroke: am5.color(0x69CA44),
      categoryXField: "country",
      tooltip: am5.Tooltip.new(root, {
        labelText: "{valueY}",
      })
    }));
    series.set("fill", am5.color(0x69CA44));
    yAxis.get("renderer").labels.template.setAll({
      fontSize: 12,
    });

    // series.columns.template.adapter.add("fill", function(fill, target) {
    //   if (target.dataItem && (target.dataItem.valueY < 0)) {
    //     return am5core.color("#a55");
    //   }
    //   else {
    //     return fill;
    //   }
    // });

    // Set data
    function generateChartData() {
      let chartData = [];

      for (var i = 0; i < data.length; i++) {
        //   let newDate = new Date(data[i].yrc);

        chartData.push({
          // year: newDate.getMonth(),
          country: data[i].TypeName,
          value: data[i].Return,
        });
      }

      return chartData;
    }

    let datanew = generateChartData();

    xAxis.data.setAll(datanew);
    series.data.setAll(datanew);


    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    series.appear(1000);
    chart.appear(1000, 100);


    return (() => {
      root.dispose();
    })
  }, [data])
  return (
    <>
      <div className='market-header'>
        <h4>Category Performance</h4>
        {/* <span>See More</span> */}
      </div>
      <Container className="table-box">
        <Row>
          <Col md={12}>
            <div className=' market-mf-main'>

              <div className="divChartDrop">
                <div className='MF-select'>
                  <select onChange={(event) => setPerformance(event.target.value)}>
                    <option>Select Category</option>
                    <option value='EQUITY'  selected={Performance === 'EQUITY'}>Equity</option>
                    <option value='HYBRID'>Hybrid</option>
                    <option value='DEBT'>Debt</option>
                  </select>
                </div>
                <div className="MF-dates">
                  <ul >
                    <li id="1WEEK" data-value="1WEEK" className={(valueLi === "1WEEK") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>1W</li>
                    <li data-value="1MONTH" className={(valueLi === "1MONTH") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>1M</li>
                    <li data-value="3MONTH" className={(valueLi === "3MONTH") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>3M</li>
                    <li data-value="6MONTH" className={(valueLi === "6MONTH") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>6M</li>
                    <li data-value="1YEAR" className={(valueLi === "1YEAR") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>1Y</li>
                    <li data-value="3YEAR" className={(valueLi === "3YEAR") ? "active" : ''} onClick={(event) => { setchartperiod(event.target.getAttribute("data-value")) }}>3Y</li>
                  </ul>
                </div>
              </div>
              {(chartData === null) ? <div className="errormsgComNew"><h3>No Data Found !!!</h3></div> : ''}
              <div id="chartdivactivity" style={{ width: "100%", height: "325px" }}></div>
            </div>
            <h6>{valueLi}</h6>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default MFActivitiChart